export const SMART_VIEWS_COLLECTION_ID = "tanstack-smart-views";
